import axios from "axios";

export default axios.create({
  baseURL: "https://api.safariranthamborebooking.com/api",
  headers: {
    "Content-Type": "application/json"
  }
});
